"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Some resrources are associated with particular sessions
// The session bar filters resources based on tags (i.e. session1, session3, etc.)
var TopFilterBar = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function TopFilterBar() {
    var _this;
    _classCallCheck(this, TopFilterBar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TopFilterBar, [].concat(args));
    _defineProperty(_this, "state", {
      currentSession: 'All'
    });
    _defineProperty(_this, "componentDidMount", function () {
      _this.props.filterUpdater(_this.state.currentSession);
    });
    _defineProperty(_this, "componentWillUnmount", function () {
      _this.props.filterUpdater('All');
    });
    _defineProperty(_this, "changeSession", function (e, session) {
      e && e.preventDefault();
      _this.props.filterUpdater(session);
      _this.setState({
        currentSession: session
      });
    });
    _defineProperty(_this, "getTagFromSession", function (session) {
      return _this.props.tags.filter(function (tag) {
        return tag.name === session;
      })[0];
    });
    _defineProperty(_this, "sessionsToTags", function () {
      var tagList = [];
      for (var i = 0; i < _this.props.topFilterBar.tags.length; i++) {
        var session = _this.props.topFilterBar.tags[i];
        tagList.push(_this.getTagFromSession(session));
      }
      return tagList;
    });
    return _this;
  }
  _inherits(TopFilterBar, _React$Component);
  return _createClass(TopFilterBar, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var sessions = this.sessionsToTags();
      if (sessions.length < 1 || typeof this.props.topFilterBar.showTopFilterBar === 'boolean' && this.props.topFilterBar.showTopFilterBar === false // This key may not exist, so check if it exists and is false
      ) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-12 text-center"
      }, /*#__PURE__*/_react["default"].createElement("nav", {
        "aria-label": "Session navigation"
      }, /*#__PURE__*/_react["default"].createElement("ul", {
        className: "pagination"
      }, this.props.topFilterBar.title && /*#__PURE__*/_react["default"].createElement("li", {
        className: "page-item disabled"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: 'page-link ' + _style["default"].label
      }, this.props.topFilterBar.title)), /*#__PURE__*/_react["default"].createElement("li", {
        className: 'page-item ' + (this.state.currentSession === 'All' ? 'active' : '')
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "page-link",
        onClick: function onClick(e) {
          return _this2.changeSession(e, 'All');
        },
        href: "#",
        "aria-label": "All Sessions"
      }, "All", ' ')), sessions.map(function (session) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          className: 'page-item ' + (_this2.state.currentSession === session.name ? 'active' : ''),
          key: session.name
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: "#",
          onClick: function onClick(e) {
            return _this2.changeSession(e, session.name);
          },
          className: "page-link"
        }, session.label));
      })))));
    }
  }]);
}(_react["default"].Component);
_defineProperty(TopFilterBar, "propTypes", {
  topFilterBar: _propTypes["default"].object.isRequired,
  tags: _propTypes["default"].array,
  filterUpdater: _propTypes["default"].func
});